.primaryButton,
.secondaryButton {
    composes: button from "../../styles/buttons.module.scss";
    color: var(--color-white) !important;
}
